class GeneralSettingsSrv {

  constructor($resource,SERVICE_URL_CONSTANT) {

// NOTIFICATIONS SERVICES
    var notification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification',{},{
      getList :{
        method:'POST'
      }
    });

    var getTeacherByfacultyId = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getTeacherByfacultyId',{},{
      getTeacherByfacultyId :{
        method:'GET'
      }
    });

    var scheduleNotificationType = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/scheduleNotifications',{},{
      getList :{
        method:'GET'
      }
    });

    var getSubjects = $resource(SERVICE_URL_CONSTANT.rosario + '/subject',{},{
     getList : {
      method:'POST'
     }
    });

    var getInfoCreateNewSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getInfoCreateNewSubject',{},{
      getList :{
        method:'GET'
      }
    });

    var createStartMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createStartMessage',{},{
      save :{
        method:'POST'
      }
    });

		var updateSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/updateSubject',{},{
      update :{
        method:'POST'
      }
    });

		var addNewSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/addNewSubject',{},{
      save :{
        method:'POST'
      }
    });

    var customNotificationData = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/customNotificationData',{},{
      getList :{
        method:'POST'
      }
    });

    var createCustomNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createCustomNotification',{},{
      save :{
        method:'POST'
      }
    });

    var disableSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/disableSubject',{},{
      disable :{
        method:'POST'
      }
    });

    var getAllDataNotificationRules = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getAllDataNotificationRules',{},{
      getList :{
        method:'GET'
      }
    });

    var createNotificationRule = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/createNotificationRule',{},{
      save :{
        method:'POST'
      }
    });

    var getNotificationById = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/getNotificationById/:notificationId',{},{
      get :{
        method:'GET'
      }
    });

    var updateNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/updateNotification',{},{
      update :{
        method:'POST'
      }
    });

//  PARAMETERS SERVICES
    var getSubmodules = $resource(SERVICE_URL_CONSTANT.rosario + '/list/getTypeList',{},{
      get :{
        method:'GET'
      }
    });

    var getListData = $resource(SERVICE_URL_CONSTANT.rosario + '/list/getLists/:idTypeList',{},{
      get :{
        method:'GET'
      }
    });

		var getSubject = $resource(SERVICE_URL_CONSTANT.rosario + '/subject/getSubject/:subjectId',{},{
      get :{
        method:'GET'
      }
    });

		var addListItem = $resource(SERVICE_URL_CONSTANT.rosario + '/list/addListItem',{},{
      add :{
        method:'POST'
      }
    });

    var changeStatus = $resource(SERVICE_URL_CONSTANT.rosario + '/list/changeListItemStatus',{},{
      change :{
        method:'POST'
      }
    });

    var disableNotification = $resource(SERVICE_URL_CONSTANT.rosario + '/notification/deleteNotification',{},{
      disable :{
        method:'POST'
      }
    });

// USERS SERVICES
    var getUsers = $resource(SERVICE_URL_CONSTANT.rosario + '/user',{},{
      get :{
        method:'POST'
      }
    });

    var getUsersWithRole = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getUsersWithRole',{},{
      get :{
        method:'GET'
      }
    });

    var getRoles = $resource(SERVICE_URL_CONSTANT.rosario + '/role/getSecRole',{},{
      get :{
        method:'GET'
      }
    });

    var disableCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/disableComiteeForUser',{},{
      post :{
        method:'POST'
      }
    });

    var disablePermit = $resource(SERVICE_URL_CONSTANT.rosario + '/user/disablePermissionForUser',{},{
      post :{
        method:'POST'
      }
    });

// CREATE USERS SERVICES
    var getFormData = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getDataFormUsers',{},{
      get :{
        method:'GET'
      }
    });

    var addPermission = $resource(SERVICE_URL_CONSTANT.rosario + '/user/addPermissionUsers',{},{
      post :{
        method:'POST'
      }
    });

// CREATE COMMITTEE SERVICES
    var getCommitteeFormData = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getDataFormComitee',{},{
      get :{
        method:'POST'
      }
    });

    var addCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/addComitee',{},{
      post :{
        method:'POST'
      }
    });

// EDIT COMMITTEE SERVICES
    var getCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getComiteeById/:comiteeId',{},{
      get :{
        method:'GET'
      }
    });

    var updateCommittee = $resource(SERVICE_URL_CONSTANT.rosario + '/user/updateComitee',{},{
      post :{
        method:'POST'
      }
    });
    //COMMITTEE BY USER
    var getCommitteersByUser = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getCommittersAndTeacherByUser/:idUser',{},{
      get :{
        method:'GET'
      }
    });

    var getCommittersByUserId = $resource(SERVICE_URL_CONSTANT.rosario + '/user/getCommittersByUserId/:idUser', {}, {
      get: {
        method: 'GET'
      }
    })

// Services Declarations
    return {
    // NOTIFICATIONS
      notification: notification,
      scheduleNotificationType: scheduleNotificationType,
      createStartMessage: createStartMessage,
      customNotificationData: customNotificationData,
      createCustomNotification: createCustomNotification,
      getInfoCreateNewSubject: getInfoCreateNewSubject,
      getAllDataNotificationRules: getAllDataNotificationRules,
      getSubjects: getSubjects,
      disableSubject: disableSubject,
      createNotificationRule: createNotificationRule,
      disableNotification: disableNotification,
      getNotificationById: getNotificationById,
      updateNotification: updateNotification,
    // PARAMETERS
      getSubmodules: getSubmodules,
      getListData: getListData,
      addListItem: addListItem,
			getSubject: getSubject,
			updateSubject: updateSubject,
      addNewSubject: addNewSubject,
      changeStatus: changeStatus,
    // USERS
      getUsers: getUsers,
      getUsersWithRole: getUsersWithRole,
      getRoles: getRoles,
      disableCommittee: disableCommittee,
      disablePermit: disablePermit,
    // CREATE USER
      getFormData: getFormData,
      addPermission: addPermission,
    // CREATE COMMETTEE
      getCommitteeFormData: getCommitteeFormData,
      addCommittee: addCommittee,
    // EDIT COMMITTEE SERVICES
      getCommittee: getCommittee,
      updateCommittee: updateCommittee,
      getTeacherByfacultyId:getTeacherByfacultyId,
      //COMMITTEE BY USER
      getCommitteersByUser,
      getCommittersByUserId
    }
  }

}

GeneralSettingsSrv.$inject=['$resource','SERVICE_URL_CONSTANT']
export default  angular.module('services.GeneralSettingsSrv', [])
.service('GeneralSettingsSrv', GeneralSettingsSrv)
.name;



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/generalSettingsSrv.js